import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";

class ImageComponent extends React.Component {
  render() {
    const { cardFront, cardBack, cardError } = this.props.cardInfo;

    return (
      <Modal isOpen={this.props.isOpen}>
        <button
          style={{ position: "absolute", right: "1rem", top: "1rem" }}
          onClick={this.props.onClose}
        >
          close
        </button>
        <p style={{ color: "red" }}>{cardError}</p>
        <h1>Front</h1>
        <img style={{ width: "30vw" }} src={cardFront} />
        <h1>Back</h1>
        <img style={{ width: "30vw" }} src={cardBack} />
      </Modal>
    );
  }
}

export default ImageComponent;
